import { Link } from 'react-router';
import { getAllDisciplines } from '../lib/disciplines.js';
import { getAllBlogPosts } from '../lib/blogs.js';
import { getOngoingEvents, getUpcomingEvents } from '../lib/events.js';
import { formatDate } from '../lib/dateUtils.js';
import { useDocumentTitle } from '../lib/useDocumentTitle.js';
import { DEFAULT_TITLE } from '../lib/seo.js';
import styles from './Home.module.css';

export default function Home() {
  useDocumentTitle(DEFAULT_TITLE, true);
  const disciplines = getAllDisciplines();
  const recentPosts = getAllBlogPosts().slice(0, 3);
  const ongoingEvents = getOngoingEvents();
  const upcomingEvents = getUpcomingEvents();
  const activeEvent = ongoingEvents[0] || upcomingEvents[0];
  const isOngoing = Boolean(ongoingEvents[0]);

  return (
    <div className="container">
      <section className={styles.masthead}>
        <div>
          <h1>YACC</h1>
          <p className={styles.mission}>
            Yet Another Coding Club, the official coding club of IIT Palakkad. Six disciplines,
            one club, and a public record of everything we build.
          </p>
          <p>
            <Link to="/projects">See our work</Link> or{' '}
            <Link to="/events">find the next event</Link>.
          </p>
        </div>
        <nav aria-label="Disciplines" className={styles.disciplineIndex}>
          <ol>
            {disciplines.map((d, i) => (
              <li key={d.slug}>
                <span className="meta">{String(i + 1).padStart(2, '0')}</span>{' '}
                <Link to={`/disciplines/${d.slug}`}>{d.shortName}</Link>
              </li>
            ))}
          </ol>
        </nav>
      </section>

      {activeEvent && (
        <section className={`section-marked ${styles.section}`}>
          <h2>
            {isOngoing ? (
              <>
                <span className="live-pulse-dot" /> Happening Now
              </>
            ) : (
              'Next up'
            )}
          </h2>
          <p className="meta">
            {formatDate(activeEvent.date)} · {activeEvent.room}
          </p>
          <p>
            <Link to={`/events/${activeEvent.slug}`}>{activeEvent.title} →</Link>
          </p>
        </section>
      )}

      <section className={`section-marked ${styles.section}`}>
        <h2>From the blog</h2>
        <ul className="hairline-list">
          {recentPosts.map((post) => (
            <li key={post.slug}>
              <h3>
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h3>
              <p className="meta">
                {post.author} · {formatDate(post.publishedDate)}
              </p>
              {post.summary && <p>{post.summary}</p>}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
